// extracted by mini-css-extract-plugin
export default {"root":"root--kKmzN error-block","title":"title--zltlI error-block__title","text":"text--kVISC"};